import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit } from '@angular/core'; // Import OnChanges and SimpleChanges
import { UntypedFormGroup, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Visibility } from '@src/app/core/enums/Visibility';
import { AccessControl } from '@src/app/models/accessControl';
import { ContactSearch } from '@src/app/models/contactSearch';
import { AppBaseComponent } from '../app-base/app-base.component';
import { ActivatedRoute } from '@angular/router';
import { LettingTenancyService } from '@src/app/core/services/letting.tenancy.service';
import { KeyValue } from '@src/app/models/system/KeyValueString';

@Component({
  selector: 'tlp-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.css']
})
// Implement OnChanges
export class AccessControlComponent extends AppBaseComponent implements OnInit, OnChanges {

  Visibility = Visibility;
  members: ContactSearch[] = [];
  // Initialize accessControl based on input or default
  accessControl = new AccessControl();
  form: UntypedFormGroup = new FormGroup({}); // Keep initialization here
  tenancyKeyValues: any[] = [];

  
  @Input() showTenancyOptions: boolean = true;
  @Input() showContactOptions: boolean = true;
  @Input()
  showVisibilityButtons: boolean = true;
  @Input()
  public visibility: Visibility | null = null ;
  @Output()
  public contactSelected = new EventEmitter<ContactSearch>();
  @Output()
  public selectedItems = new EventEmitter<any[]>();
  @Output()
  public updateACL = new EventEmitter<AccessControl>();
  @Input()
  public acl: AccessControl | null = null; // Initialize to null or undefined is often clearer
  @Input()
  propertyId:number = 0;   

  memberIds: number[] = []; // for selected member id's on load
  tenancyIds: number[] = []; // for selected tenancy id's on load

  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly lettingTenancyService: LettingTenancyService
  ) { 
    super();

    

  }

  ngOnInit(): void {
    // Initialize form first
    this.generateForm();

    
    //handle inputs
    if(!this.acl){      
      this.acl = new AccessControl();
    }
      this.acl.visibility = this.visibility ?? this.acl.visibility ?? Visibility.Private;
      // this.visibility = this.acl.visibility ?? Visibility.Private;

    // Then process initial input value
    this.processAclInput(this.acl);

    // Emit initial value if needed (consider if parent already has this)
    // this.emitAccessControl(); // Maybe not needed on init if parent provides the initial value

    //lets see if we can get a  propertyId here
    const propertyId = (this.propertyId > 0) ? this.propertyId : Number(this.findParameter(this.route, 'propertyId') ?? '');
    if(propertyId && this.showTenancyOptions){
    // LettingTenancyService.GetAllTenanciesByProperty
    this.lettingTenancyService.GetAllTenanciesSummariesByProperty(propertyId).subscribe({
      next: (tenancies) => {
        // get information to show on ui
        this.tenancyKeyValues = tenancies.map((tenancy) => {
          const startDate = this.parseUTCDateString(tenancy.dateStart.toString());
          
          const formatDate = (date: Date) => {
            
            const day = date.getDate().toString().padStart(2, '0');
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
          };

          let leadTenants = (tenancy.leadTenants?.length > 0) ? tenancy.leadTenants.map( t => t.fullName) : 'No Lead Tenant'

          return new KeyValue(
            tenancy.id,
            `${tenancy.propertyId}-${tenancy.id } - ${leadTenants} - Start: ${formatDate(startDate)} (${tenancy.lifecycleStatus}}`
          );
        });
        console.log(this.tenancyKeyValues)
      },
      error: (error) => {
        console.error('Error loading tenancies:', error);
      }
    });

    }

  }

  // Implement the ngOnChanges method
  ngOnChanges(changes: SimpleChanges): void {
    // Check if the 'acl' input property changed
    if (changes['acl'] && changes['acl'].currentValue) {
      // Get the new value
      const newAcl: AccessControl | null = changes['acl'].currentValue;
      this.processAclInput(newAcl);
    }
  }

  // Helper function to process ACL input (used by OnInit and OnChanges)
  private processAclInput(inputAcl: AccessControl | null): void {

    // Use default if input is null or undefined
//     const effectiveAcl =  new AccessControl();
//       effectiveAcl.visibility = inputAcl?.visibility ?? Visibility.Private;
// effectiveAcl.members = inputAcl?.members ?? [];
// effectiveAcl.tenancies = inputAcl?.tenancies ?? [];

     this.accessControl = inputAcl ?? new AccessControl();
    //  this.accessControl.visibility = this.visibility ?? this.accessControl.visibility ?? Visibility.Private;
      // this.visibility = this.accessControl.visibility ?? Visibility.Private;



   // this.visibility = effectiveAcl.visibility ?? Visibility.Private;
    // this.acl.visibility = this.visibility;

    // if(inputAcl?.tenancies)
    //   this.acl.tenancies = inputAcl.tenancies;
    // if(inputAcl?.members)
    //   this.acl.members = inputAcl.members;

    //this.acl = effectiveAcl; // Store the effective ACL


    //this.acl = effectiveAcl; // Store the effective ACL
    //this.visibility = effectiveAcl.visibility ?? Visibility.Unrestricted;
    // Update the internal accessControl model to match the input
    //this.accessControl = { ...effectiveAcl }; // Create a copy to avoid direct mutation of input

    //this.acl = this.mergeApiData(this.acl, inputAcl ?? new AccessControl); // Merge)
    
    if(this.accessControl.visibility != Visibility.SelectedContacts) {
      // Clear members/tenancies  if visibility is not SelectedContacts
      this.accessControl.members = []; 
      this.accessControl.tenancies = []; 
    }
    // update members
  //  this.members = [...this.acl.members]; // Update members if needed for display
    this.memberIds = inputAcl!.members.map(m => m.id); // Assuming ContactSearch has an 'id' property
    this.tenancyIds = inputAcl!.tenancies.map(m => m.key); // Update members if needed for display

    // Update the form value if the form has been initialized
    if (this.form) {
      this.form.patchValue({
        visibility: this.accessControl.visibility!.toString() // Ensure it's a string for the form control
      });
    }
    // console.log('ACL Input processed:', this.accessControl);
    // Avoid emitting back immediately after receiving input unless necessary
    // this.emitAccessControl();
  }

  /**
   * Merges API data into an existing object, ONLY updating properties
   * that exist in the API response with non-null/undefined values
   */
  mergeApiData<T extends object>(existing: T, apiData: Partial<T>): T {
    const filteredData = Object.fromEntries(
      Object.entries(apiData).filter(([_, value]) => {
        // Only include properties that exist in apiData (not undefined)
        // AND have non-null values
        return value !== undefined && value !== null;
      })
    ) as Partial<T>;

    return { ...existing, ...filteredData };
}


  public get preselectedTenancies(): any[] {
    let selectedTenancies = this.tenancyKeyValues.filter(t => this.tenancyIds.includes(Number(t.key)));
    return selectedTenancies;  }


  public generateForm(): void {
    // Initialize with default or potentially current visibility
    this.form = this.fb.group({
      contact: [''], // Assuming this is for adding new contacts, keep it empty
      // Initialize visibility based on the current state
      visibility: [this.accessControl.visibility?.toString(), Validators.required],
      tenancy: [''] // Add tenancy control
    });

    // Optional: Subscribe to form changes if you want immediate updates
    // this.form.get('visibility')?.valueChanges.subscribe(value => {
    //   this.onVisibilityChange(value);
    // });
  }

  // Modified to handle direct value or event object
  onVisibilityChange(eventOrValue: any): void {
    let selectedValueStr: string | null = null;

    // Check if it's an event object or a direct value
    if (eventOrValue && eventOrValue.target && typeof eventOrValue.target.value !== 'undefined') {
      selectedValueStr = eventOrValue.target.value; // From <select> change event
    } else if (typeof eventOrValue === 'string' || typeof eventOrValue === 'number') {
      selectedValueStr = eventOrValue.toString(); // From form valueChanges or direct call
    }

    if (selectedValueStr !== null) {
      const selectedValue = parseInt(selectedValueStr, 10);
      if (!isNaN(selectedValue) && Visibility[selectedValue] !== undefined) {
        //  this.visibility = selectedValue as Visibility;
         // Update the internal model directly
         this.accessControl.visibility = selectedValue as Visibility;; //this.visibility;
         if(this.visibility != Visibility.SelectedContacts) 
            this.accessControl.members = []; // Clear members if visibility is not SelectedContacts
         // Patch form just in case the change came from outside the form itself
         this.form.patchValue({ visibility: this.accessControl.visibility.toString() }, { emitEvent: false }); // Prevent infinite loops if using valueChanges
         this.emitAccessControl();
      } else {
        console.warn('Invalid visibility value received:', selectedValueStr);
      }
      this.emitAccessControl(); // Emit the updated access control after visibility change
    }
  }

  emitAccessControl() {
  const payload = {
    ...this.accessControl,
    tenancies: this.accessControl.tenancies.map(t => ({
      key: Number(t.key), // Ensure numeric key
      value: t.value
    }))
  };
  this.updateACL.emit(payload);
}

  // private emitAccessControl(): void {
  //   // Ensure the visibility in the emitted object is correct
  //   this.accessControl.visibility = this.visibility;
  //   // Ensure members are also up-to-date before emitting
  //   // this.accessControl.members = [...this.members]; // Redundant if members array is directly managed

  //   // Emit a *copy* of the accessControl object
  //   this.updateACL.emit({ ...this.accessControl });
  //   // console.log('Emitting AccessControl:', { ...this.accessControl });
  // }

  onContactSelected(contact: ContactSearch): void {
    // Avoid duplicates if necessary
    if (!this.accessControl.members.some(m => m.id === contact.id)) { // Assuming ContactSearch has an 'id'
       this.accessControl.members.push(contact);
       this.members = [...this.accessControl.members]; // Update local members if used by template
       this.emitAccessControl();
    }
  }

  onSelectedContacts(contacts: ContactSearch[]): void {
    // Replace members entirely
    this.accessControl.members = [...contacts]; // Use a copy
    this.members = [...this.accessControl.members]; // Update local members if used by template
    this.emitAccessControl();
  }

  onTenancySelected(tenancies: KeyValue[]): void {
  // Replace tenancies entirely WITH MAPPING
  this.accessControl.tenancies = tenancies.map(t => ({
    key: Number(t.key), // Ensure numeric key
    value: t.value
  }));
  // this.tenancies = [...this.accessControl.tenancies]; // Sync local state
  this.emitAccessControl();
}
//   onTenancySelected(tenancies: KeyValue[]): void {
//   // Filter out tenancies already in the list
//   const newTenancies = tenancies.filter(t => 
//     !this.accessControl.tenancies.some(m => m.key === t.key)
//   );
  
//   if (newTenancies.length > 0) {
//     // Add all new tenancies at once
//     this.accessControl.tenancies = [
//       ...this.accessControl.tenancies,
//       ...newTenancies.map(t => ({
//         key: Number(t.key), // Ensure numeric key
//         value: t.value
//       }))
//     ];
//     this.emitAccessControl();
//   }
// }
//   onTenancySelected(tenancy: KeyValueString): void {
//     // this.form.patchValue({ tenancy: tenancy.key });
//       if (!this.accessControl.tenancies.some(m => m.key === tenancy.key)) { // Assuming ContactSearch has an 'id'
//        this.accessControl.tenancies.push(tenancy);
//       //  this.te = [...this.accessControl.members]; // Update local members if used by template
//        this.emitAccessControl();
//     }
//     this.emitAccessControl();
//   }
}
